import { PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  payment_methods: {
    [PaymentMethod.Card]: 'Kreditkort',
    [PaymentMethod.Sofort]: 'Sofort',
    [PaymentMethod.Giropay]: 'Giropay',
    [PaymentMethod.PayByBank]: 'Betal via bank',
    [PaymentMethod.SepaDebit]: 'EC-kort / IBAN',
    [PaymentMethod.Cash]: 'Kontant',
    [PaymentMethod.Link]: 'Link',
    [PaymentMethod.StripeOther]: 'Anden betalingsmetode',
  },
};
